import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { ActorSubType } from "../../../../../../../Wrap/Constants/Enums/ActorSubType";

interface IClientPortalAccessProps extends IProcessComponentProps {
    data: ApplyModel;
}

interface IClientPortalAccessState {
    hasSelected: boolean;
}

export class ClientPortalAccess extends ProcessComponent<IClientPortalAccessProps, IClientPortalAccessState> {
    constructor(props: IClientPortalAccessProps) {
        super(props);
        this.state = {
            hasSelected: props?.data?.ClientPortalAccess || props?.data?.SecondClientPortalAccess ? true : false,
        };
    }

    isValid() {
        const isPass = !this.props.data?.IsJointAccount
            ? true
            : !this.state.hasSelected
            ? true
            : this.props?.data?.ClientPortalAccess || this.props?.data?.SecondClientPortalAccess;
        if (!isPass) {
            this.props.showErrorMsgPopUp(["Please at leaset select one customer to have the read only access"]);
        }
        return super.isValid() && isPass;
    }

    private renderClientPortalAccess() {

        const { data, onChange } = this.props;
        return (
            <>
                <h2 className="mb-22">Client portal access</h2>
                {!data?.IsJointAccount ? (
                    <div>
                        <RadiosEditor
                            cssWrapper="rg-inline mb-16"
                            label="Setting access to Yes will enable the customer's profile for user access. To complete the new user registration, please select Create User from the client's Activity tab after submission of new business."
                            selected={data?.ClientPortalAccess || false}
                            options={[true, false]}
                            disabled={data?.ClientDetails?.ActorSubType == ActorSubType.Child}
                            getText={(v) => (v ? "Yes" : "No")}
                            onChange={(v) => {
                                onChange({ ClientPortalAccess: v });
                            }}
                        />
                        <p className="mb-15" style={{display: data?.ClientDetails?.ActorSubType == ActorSubType.Child ? 'block' : 'none'}}>
                            Access is not permitted for Child clients. If Parent/Guardian requires access to this account, please enable this from the Roles tab upon submission of this process.
                        </p>
                    </div>
                ) : (
                    <>
                        <RadiosEditor
                            cssWrapper="rg-inline mb-16"
                            label="Setting access to Yes will enable the customer's profile for user access.  To complete the new user registration, please select Create User from the client's Activity tab after submission of new business."
                            selected={data?.ClientPortalAccess || data?.SecondClientPortalAccess || false}
                            options={[true, false]}
                            disabled={data?.ClientDetails?.ActorSubType == ActorSubType.Child}
                            getText={(v) => (v ? "Yes" : "No")}
                            onChange={(v) => {
                                this.setState({ hasSelected: v });
                                if (!v) {
                                    onChange({ ClientPortalAccess: false, SecondClientPortalAccess: false });
                                } else {
                                    onChange({ ClientPortalAccess: v });
                                }
                            }}
                        />
                        {this.state.hasSelected && (
                            <CheckboxGroup
                                type="block"
                                wrapCss="mb-0"
                                options={[
                                    {
                                        label: data?.ClientDetails?.FirstName + " " + data?.ClientDetails?.LastName,
                                        value: data?.ClientPortalAccess,
                                        onChange: (v) => {
                                            onChange({ ClientPortalAccess: v });
                                        },
                                    },
                                    {
                                        label:
                                            data?.SecondClientDetails?.FirstName +
                                            " " +
                                            data?.SecondClientDetails?.LastName,
                                        value: data?.SecondClientPortalAccess,
                                        onChange: (v) => {
                                            onChange({ SecondClientPortalAccess: v });
                                        },
                                    },
                                ]}
                            />
                        )}
                    </>
                )}
            </>
        );
    }

    render() {
        return <>{this.renderClientPortalAccess()}</>;
    }
}